import { useInfiniteQuery } from "@tanstack/react-query";
import { fetchClient } from "@/lib/api-client";

interface UseFetchPurchaseHistoryParams {
  limit?: number;
}

export const useFetchPurchaseHistory = (
  params?: UseFetchPurchaseHistoryParams,
) => {
  const { limit = 10 } = params || {};

  const queryFn = async ({ pageParam = 1 }) => {
    const response = await fetchClient.GET("/nft/purchase-history", {
      params: {
        query: {
          page: +pageParam || 1,
          limit,
        },
      },
    });
    const error = response.error;
    if (error) throw error;
    return response.data;
  };

  const {
    data,
    error,
    isLoading,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    isFetching,
    isFetchNextPageError,
  } = useInfiniteQuery({
    queryKey: ["nft", "purchase-history", limit],
    queryFn,
    initialPageParam: 1,
    getNextPageParam: (lastPage) => {
      const pagination = lastPage?.data?.pagination;

      if (pagination?.hasNextPage) return pagination.page + 1;

      return undefined;
    },
  });

  return {
    data,
    error,
    isLoading,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    isFetching,
    isFetchNextPageError,
  };
};
